import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useRushLeaderboard } from '../../hooks/useRushLeaderboard';
import { RushLeaderboard } from './RushLeaderboard';

interface Props {
  isOpen: boolean;
  onSignInClick: () => void;
}

export const RushLeaderboardPanel: React.FC<Props> = ({ isOpen, onSignInClick }) => {
  const { user } = useAuth();
  const { entries, currentUser, isLoading, hasMore, loadMore, loadingMore } =
    useRushLeaderboard({ enabled: isOpen });

  if (!isOpen) return null;

  return (
    <div
      className="fixed right-0 bottom-0 w-[380px] max-w-full flex flex-col overflow-hidden"
      style={{
        top: '52px',
        backgroundColor: 'hsl(var(--background) / 0.92)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderLeft: '1px solid hsl(var(--border))',
        animation: 'rush-slide-in 300ms ease-out',
        zIndex: 9,
      }}
    >
      {/* Scrollable content */}
      <div className="flex-1 overflow-y-auto px-4 pb-6 pt-4 flex flex-col">
        <RushLeaderboard
          entries={entries}
          currentUser={currentUser}
          isLoading={isLoading}
          hasMore={hasMore}
          loadMore={loadMore}
          loadingMore={loadingMore}
          isAuthenticated={!!user}
          onSignInClick={onSignInClick}
        />
      </div>
    </div>
  );
};
